export default {
  clear() {
    sessionStorage.clear();
  },
  setSession(key, value) {
    if (value == null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage[key] = typeof (value) === "object" ? JSON.stringify(value) : value;
    }
  },
  getSession(key) {
    try {
      return JSON.parse(sessionStorage[key]);
    } catch (e) {
      return sessionStorage[key];
    }
  },



  // 调用接口需要写到head里面的接口调用证书
  set authorization(authorization) {
    this.setSession("authorization", authorization);
  },
  get authorization() {
    return this.getSession("authorization");
  },
  // 当前登录用户信息
  set user(user) {
    this.setSession("user", user);
  },
  get user() {
    return this.getSession("user");
  },
  // 当前登录用户信息
  set liveUser(user) {
    this.setSession("liveUser", user);
  },
  get liveUser() {
    return this.getSession("liveUser");
  },
  // 当前登录用户信息
  set wheatTask(wheatTask) {
    this.setSession("wheatTask", wheatTask);
  },
  get wheatTask() {
    return this.getSession("wheatTask");
  }
}



// WEBPACK FOOTER //
// ./src/utils/Session.js